var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', [_c('sub-visual', {
    attrs: {
      "subTab": "",
      "sh": "About us",
      "index": "04",
      "total": "04",
      "tabActive": "위치",
      "bg": "/images/sub/visual/sv1.jpg"
    }
  }), _c('section', {
    staticClass: "section section--first pb-0"
  }, [_c('v-container', [_c('div', {
    staticClass: "tit-wrap"
  }, [_c('h2', {
    staticClass: "tit tit--lg dot-tit"
  }, [_vm._v("위치")])]), _c('v-tabs', {
    staticClass: "v-tab--primary",
    attrs: {
      "grow": "",
      "show-arrows": "",
      "center-active": ""
    }
  }, [_c('v-tab', {
    attrs: {
      "to": "/ko/aboutus/location/paju"
    }
  }, [_c('span', [_vm._v("파주 본사")])]), _c('v-tab', {
    attrs: {
      "to": "/ko/aboutus/location/ulsan"
    }
  }, [_c('span', [_vm._v("울산 지점")])]), _c('v-tab', {
    attrs: {
      "to": "/ko/aboutus/location/daesan"
    }
  }, [_c('span', [_vm._v("대산 지점")])])], 1)], 1)], 1), _c('section', {
    staticClass: "section section--last pt-0"
  }, [_c('v-container', [_c('div', {
    staticClass: "h-400px h-lg-600px"
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "id": "map2"
    }
  })]), _c('div', {
    staticClass: "pt-60 pt-md-80 pt-lg-100"
  }, [_c('h3', {
    staticClass: "tit top-line-tit mb-16 mb-md-50 mb-lg-80"
  }, [_vm._v("Contact us")]), _c('v-divider'), _c('div', {
    staticClass: "py-20 py-md-40"
  }, [_c('v-row', {
    attrs: {
      "align": "center",
      "justify-xl": "space-between"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "auto"
    }
  }, [_c('v-row', {
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-img', {
    attrs: {
      "src": "/images/icon/icon-tel.png"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": ""
    }
  }, [_c('span', [_vm._v("010-2546-9378")])])], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "auto"
    }
  }, [_c('v-row', {
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-img', {
    attrs: {
      "src": "/images/icon/icon-mail.png"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": ""
    }
  }, [_c('span', [_vm._v("khan@kiesys.co.kr")])])], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "auto"
    }
  }, [_c('v-row', {
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-img', {
    attrs: {
      "src": "/images/icon/icon-address.png"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": ""
    }
  }, [_c('span', [_vm._v("(31906) 충남 서산시 대산읍 명지1로 238, 104호")])])], 1)], 1)], 1)], 1), _c('v-divider')], 1)])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }